/* ESTO ES UN ARCHIVO AUTO GENERADO, FAVOR DE NO EDITAR, USAR bin/import.js */
import React from 'react'

import classNames from 'classnames'

import './Icon.scss'

import {
  ICONS4,
  ICONS14,
  ICONS16,
  ICONS20,
  ICONS24,
  ICONS32
} from '../../helpers/icons'

const ICONS = {
  4: ICONS4,
  14: ICONS14,
  16: ICONS16,
  20: ICONS20,
  24: ICONS24,
  32: ICONS32
}

const ALL_ICONS = Object.values(ICONS)
const findIcon = (icon) => {
  const icons = ALL_ICONS.find(icons => icons[icon])
  if (!icons) {
    console.log('Icon not found: ' + icon)
  }
  return icons && icons[icon]
}

const Icon = ({ size, icon }) => {
  return (
    <div className={classNames('icon', '-size-' + size)}>
      {ICONS[size][icon] || findIcon(icon)}
    </div>
  )
}

export default Icon
